"use client";

import { useTranslations } from "next-intl";
import React from "react";
import type { UseFormReturn } from "react-hook-form";
import { FormSelect } from "@/components/form/form-select";
import useMultidietSetupStore from "@/features/multidiet-picker/store/multidiet-picker.store";
import type { MultidietPickerFormType } from "@/features/multidiet-picker/types/multidiet-picker-form.type";
import { cn } from "@/lib/utils";

export const MultidietPickerFormMobile = ({
  layout,
  form,
}: {
  layout: "page" | "popup";
  form: UseFormReturn<MultidietPickerFormType>;
}) => {
  const t = useTranslations();
  const { multidietSetup } = useMultidietSetupStore();

  const handleEdit = () => {
    form.trigger();
  };

  if (!multidietSetup) return null;

  // Ensure CUSTOM_CHOICE is the first option
  const dietTypesOrdered = React.useMemo(() => {
    const types = [...multidietSetup.dietTypes];
    const idx = types.findIndex((t) => t.dietTag === "CUSTOM_CHOICE");
    if (idx > 0) {
      const [custom] = types.splice(idx, 1);
      if (custom) {
        types.splice(0, 0, custom);
      }
    }
    return types;
  }, [multidietSetup.dietTypes]);

  return (
    <div
      className={cn(
        "flex w-full min-w-0 max-w-full flex-col items-stretch justify-center gap-2 p-4 md:gap-5 lg:flex-row",
        layout === "popup" && "rounded-xl bg-brand-grey1"
      )}
    >
      {multidietSetup && (
        <FormSelect
          className="min-w-0 flex-1"
          clearable={false}
          fieldName="dietTypeMobile"
          fieldOptions={dietTypesOrdered.map((tag) => ({
            label: <span>{t(`dietTags.${tag.dietTag}`)}</span>,
            value: tag.dietTag,
          }))}
          form={form}
          layout="big"
          onChange={handleEdit}
        />
      )}
      {multidietSetup && (
        <FormSelect
          className="min-w-0 flex-1"
          clearable={false}
          fieldName="calories"
          fieldOptions={multidietSetup.calories.map((calory) => ({
            label: <span>{t("common.kcal", { kcal: calory })}</span>,
            value: calory.toString(),
          }))}
          form={form}
          layout="big"
          onChange={handleEdit}
        />
      )}
    </div>
  );
};
